import React from 'react';

const BackgroundParticles = () => {
  // Generate random positions for large glowing nodes
  const largeNodes = React.useMemo(() => [
    { top: `${Math.random() * 20 + 5}%`, left: `${Math.random() * 80 + 10}%`, size: 'w-16 h-16', delay: '0s', glow: 'shadow-[0_0_20px_rgba(59,130,246,0.3)]' },
    { top: `${Math.random() * 20 + 25}%`, left: `${Math.random() * 80 + 10}%`, size: 'w-20 h-20', delay: '1s', glow: 'shadow-[0_0_25px_rgba(59,130,246,0.35)]' },
    { top: `${Math.random() * 20 + 50}%`, left: `${Math.random() * 80 + 10}%`, size: 'w-18 h-18', delay: '2s', glow: 'shadow-[0_0_22px_rgba(59,130,246,0.3)]' },
    { top: `${Math.random() * 20 + 40}%`, left: `${Math.random() * 80 + 10}%`, size: 'w-16 h-16', delay: '3s', glow: 'shadow-[0_0_20px_rgba(59,130,246,0.3)]' },
    { top: `${Math.random() * 20 + 15}%`, left: `${Math.random() * 80 + 10}%`, size: 'w-18 h-18', delay: '4s', glow: 'shadow-[0_0_22px_rgba(59,130,246,0.3)]' }
  ], []);

  // Generate random positions for scattered nodes
  const scatteredNodes = React.useMemo(() => 
    Array.from({ length: 20 }, (_, i) => ({
      top: `${Math.random() * 90 + 5}%`,
      left: `${Math.random() * 90 + 5}%`,
      size: ['w-8 h-8', 'w-9 h-9', 'w-10 h-10', 'w-11 h-11', 'w-12 h-12'][Math.floor(Math.random() * 5)],
      delay: `${i * 0.4}s`,
      animated: Math.random() > 0.5,
      id: `node-${i}`
    }))
  , []);

  return (
    <div className="absolute inset-0 pointer-events-none" style={{ zIndex: 0 }}>
      {/* Large glowing nodes with pulsing effect */}
      {largeNodes.map((node, i) => (
        <div
          key={`large-${i}`}
          className={`absolute ${node.size} rounded-full bg-blue-500/5 border-2 border-blue-500/40 ${node.glow}`}
          style={{
            top: node.top,
            left: node.left,
            animation: 'pulse 6s ease-in-out infinite',
            animationDelay: node.delay
          }}
        />
      ))}

      {/* Random scattered nodes with glowing effect */}
      {scatteredNodes.map((node, i) => (
        <div
          key={`outer-${i}`}
          className={`absolute ${node.size} rounded-full bg-slate-700/8 border border-slate-600/25`}
          style={{
            top: node.top,
            left: node.left,
            animation: node.animated 
              ? `pulse 6s ease-in-out infinite, ${i % 2 === 0 ? 'glowPulse' : 'glowPulseStrong'} 4s ease-in-out infinite`
              : 'pulse 6s ease-in-out infinite',
            animationDelay: node.delay,
            boxShadow: '0 0 15px rgba(100, 116, 139, 0.2)'
          }}
        >
          <div className="absolute inset-1 rounded-full bg-slate-600/10" style={{ boxShadow: 'inset 0 0 10px rgba(100, 116, 139, 0.15)' }} />
        </div>
      ))}

      {/* Floating data particles */}
      {[...Array(40)].map((_, i) => (
        <div
          key={i}
          className="absolute w-1 h-1 bg-blue-400 rounded-full"
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animation: `float ${5 + Math.random() * 5}s ease-in-out infinite`,
            animationDelay: `${Math.random() * 3}s`,
            opacity: 0.5
          }}
        />
      ))}

      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0) translateX(0); }
          25% { transform: translateY(-20px) translateX(10px); }
          50% { transform: translateY(-10px) translateX(-10px); }
          75% { transform: translateY(-30px) translateX(5px); }
        }
        
        @keyframes glowPulse {
          0%, 100% { 
            box-shadow: 0 0 15px rgba(100, 116, 139, 0.2);
          }
          50% { 
            box-shadow: 0 0 30px rgba(59, 130, 246, 0.6), 0 0 50px rgba(59, 130, 246, 0.3);
          }
        }
        
        @keyframes glowPulseStrong {
          0%, 100% { 
            box-shadow: 0 0 20px rgba(59, 130, 246, 0.3);
          }
          50% { 
            box-shadow: 0 0 40px rgba(59, 130, 246, 0.8), 0 0 60px rgba(59, 130, 246, 0.4);
          }
        }
      `}</style>
    </div>
  );
};

export default BackgroundParticles;
